import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const PlusCircleIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
      fill="currentColor"
    />
  </svg>
);

PlusCircleIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(PlusCircleIcon);
